'use client';

import React from 'react';
import styles from './SettingTab.module.scss';

interface SettingButtonProps {
  icon: React.ReactNode;
  text: string;
  onClick?: () => void;
  className?: string;
}

/**
 * Basic setting button component with an icon and text
 */
const SettingButton: React.FC<SettingButtonProps> = ({ 
  icon, 
  text, 
  onClick,
  className = ''
}) => {
  return (
    <button className={`${styles.settingButton} ${className}`} onClick={onClick}>
      <div className={styles.iconWrapper}>
        {icon}
      </div>
      <span className={styles.settingText}>{text}</span>
    </button>
  );
};

export default SettingButton;
